// Page-specific items for the global right-click menu (ErpContextMenu.jsx).
//
// A page that wants extra actions on its own elements registers a provider
// instead of opting out of the global menu (data-erp-context-menu-exempt) and
// drawing its own — opting out also loses Quick Filter, Alt-pick, tabs, etc.
//
//   useEffect(() => registerContextActions((target) => [
//     { key: "bold", icon: Bold, label: "Bold Rate", onClick: () => ... },
//   ]), [deps]);
//
// A provider gets the right-clicked element and returns an array of items (or
// nothing). Items render at the top of the menu, under Filter.

const providers = new Set();

export function registerContextActions(fn) {
  providers.add(fn);
  return () => providers.delete(fn);
}

export function collectContextActions(target) {
  const out = [];
  providers.forEach((fn) => {
    try {
      const items = fn(target);
      if (Array.isArray(items)) out.push(...items.filter(Boolean));
    } catch { /* a broken provider must not kill the menu */ }
  });
  return out;
}
